import urls from '../../../util/urls';
import customAppsActionTypes from './actionTypes';

function fetchCustomApps() {
  return async (dispatch: any) => {
    await dispatch({
      type: customAppsActionTypes.FETCH_CUSTOM_APPS,
      url: urls.api.customApps(),
    });
  };
}

export default {
  fetchCustomApps,
};
